import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c41d9fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["transform"]
const _hoisted_3 = ["d"]

import { computed, ref, watch } from 'vue'
import { hfmath } from './hfmath'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormulaContent',
  props: {
  latex: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const box = ref({ x: 0, y: 0, w: 0, h: 0 })
const pathd = ref('')

watch(() => props.latex, () => {
  const eq = new hfmath(props.latex)
  pathd.value = eq.pathd({})
  box.value = eq.box({})
}, { immediate: true })

const scale = computed(() => {
  const boxW = box.value.w + 32
  const boxH = box.value.h + 32

  if (boxW > props.width || boxH > props.height) {
    if (boxW / boxH > props.width / props.height) return props.width / boxW
    return props.height / boxH
  }
  return 1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "formula-content",
    overflow: "visible",
    width: box.value.w + 32,
    height: box.value.h + 32,
    stroke: "#000",
    "stroke-width": "1",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    _createElementVNode("g", {
      transform: `scale(${_unref(scale)}, ${_unref(scale)}) translate(0,0) matrix(1,0,0,1,0,0)`,
      "transform-origin": "0 50%"
    }, [
      _createElementVNode("path", { d: pathd.value }, null, 8, _hoisted_3)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})